/** Long labels of the header opportunity pill (list options and selected chip), by opportunity key. */
export const OPPORTUNITY_FILTER_LABELS: Record<string, string> = {
  seo_boost: 'dashboard.nonBrand.opportunities.organicBoost',
  sea_boost: 'dashboard.nonBrand.opportunities.cpcBoost',
  missed: 'dashboard.nonBrand.opportunities.missed',
  no_opportunity: 'dashboard.nonBrand.opportunities.noOpportunity',
};

export const opportunityFilterOptions = (t: (key: string) => string) =>
  Object.entries(OPPORTUNITY_FILTER_LABELS).map(([value, key]) => ({ label: t(key), value }));
